import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from '../ui_game_players/UIGamePlayerInformationView'
import {ItemCountView} from '../../ui_canvas_engine/ItemCountView'
import {TranslationObject} from '@colonist/i18n'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'

export abstract class UIGamePlayerInformationKnightView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly isMyPlayer: boolean
    readonly knightPlayerValidator: MechanicValidatorKnightPlayer
    protected readonly playerInformation: UIGamePlayerInformationView

    protected knightStrengthView?: ItemCountView

    constructor(uiGameManager: UIGameManager, knightPlayerValidator: MechanicValidatorKnightPlayer) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.knightPlayerValidator = knightPlayerValidator

        const playerInformation = this.uiGameManager.playersController?.getPlayerInformationViewWithColor(this.knightPlayerValidator.playerColor)
        if(playerInformation == undefined) return
        this.playerInformation = playerInformation

        const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor
        this.isMyPlayer = this.playerInformation.player.color == bottomPlayerColor
        this.isMyPlayer ? this.createMyKnightStateView() : this.createOpponentKnightView()
        this.createTooltip()
        this.updateKnightStrengthCount()
    }

    private createTooltip() {
        if(UIUtilsEjsVariables.isUserOnMobileApp) return
        const knightStrengthViewTipTitle: TranslationObject = {key: 'strings:game.playerInformation.knightStrength.title'}
        const knightStrengthViewTipBody: TranslationObject = {key: 'strings:game.playerInformation.knightStrength.body'}
        this.knightStrengthView?.view.setTip(knightStrengthViewTipTitle, [knightStrengthViewTipBody])
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.KnightStateUpdated: this.updateKnightStrengthCount(); break
            case UIGameEventEnums.HoveredOverPlayerInformationArrow: this.knightStrengthView?.hideView(); break
            case UIGameEventEnums.PointerOutPlayerInformationView: this.knightStrengthView?.showView(this.playerInformation); break
            default: break
        }
    }

    protected abstract createMyKnightStateView(): void
    protected abstract createOpponentKnightView(): void

    private updateKnightStrengthCount() {
        const newKnightStrength = this.knightPlayerValidator.getPlayerKnightStrength()
        this.knightStrengthView?.updateText({key: 'strings:colonistCommon.utils.#buffer', options: {value: newKnightStrength}})
    }

    highlight(doesPlayerHaveHighestKnightStrength: boolean) {
        if(this.knightStrengthView == undefined) return
        const defaultKnightTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_swords)
        const doesPlayerHaveHighestKnightStrengthTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_swords_highlight)
        doesPlayerHaveHighestKnightStrength ? this.knightStrengthView.view.updateTexture(doesPlayerHaveHighestKnightStrengthTexture) : this.knightStrengthView.view.updateTexture(defaultKnightTexture)
    }

    destroy() {
        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
